// Heda Platform mode (one URL for all apps). Opt-in at build time with
// REACT_APP_PLATFORM=1; PUBLIC_URL is the sub-path the app is served under
// (e.g. /assistant) and REACT_APP_BACKEND_URL its API (e.g. /assistant-api).
// Without them the app runs standalone on its own domain, as before.

export const PLATFORM = process.env.REACT_APP_PLATFORM === "1";
export const BASE = process.env.PUBLIC_URL || "";

// The platform shares the origin with the other apps, so this app's keys
// carry its own prefix.
export const TOKEN_KEY = "heda_pa_token";
export const USER_KEY = "heda_pa_user";

export const TOP_UP_URL = "/workspace/credits";

// A path inside this app ("/product/X") as a plain href.
export const appUrl = (path) => `${BASE}${path}`;

// One-time move from the old, generic key names, so people signed in on
// the standalone domain stay signed in. Standalone only: on the platform's
// shared origin "heda_token" may belong to another app.
export function migrateStorageKeys() {
  if (PLATFORM) return;
  try {
    for (const [oldKey, newKey] of [["heda_token", TOKEN_KEY], ["heda_user", USER_KEY]]) {
      const v = localStorage.getItem(oldKey);
      if (v !== null && localStorage.getItem(newKey) === null) {
        localStorage.setItem(newKey, v);
        localStorage.removeItem(oldKey);
      }
    }
  } catch {
    /* storage blocked: nothing to move */
  }
}

// The platform's sign-in page, coming back here afterwards.
export function platformLogin() {
  const next = window.location.pathname + window.location.search;
  window.location.assign(`/login?next=${encodeURIComponent(next)}`);
}

// The exchange token the platform launcher puts in the hash, or "".
export function hashPlatformToken() {
  const m = window.location.hash.match(/platform_token=([^&]+)/);
  return m ? decodeURIComponent(m[1]) : "";
}

// The platform's help button (it reads localStorage.heda_platform_token itself).
export function loadHelpWidget() {
  if (!PLATFORM || document.getElementById("heda-help-widget")) return;
  const s = document.createElement("script");
  s.id = "heda-help-widget";
  s.src = "/help-widget.js";
  s.defer = true;
  document.body.appendChild(s);
}

// Out of credits / not in plan: the platform's message, from an AI call.
export const CREDITS_EVENT = "heda-pa-credits";
